<script>
    const serverSrc='https://HKHK.US';
    // const serverSrc='http://192.168.0.3:8000';
    export default
    {
        serverSrc,//服务器地址
    }
</script>